import React, { useEffect } from "react";
import { useClient } from "../../shared/hooks/client-hook";
import { RefreshIcon } from "@heroicons/react/outline";
import { db, storage } from "../../shared/hooks/firebase";

const ScenePanel = () => {
  const { client } = useClient();

  function setClient(newClient) {
    db.ref("/client").set(newClient);
  }

  function updateSky() {
    //open file dialog asking for image

    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (e) => {
      //get file
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        //get data url
        const dataUrl = event.target.result;

        //save file in assets/image/sky.png

        const ref = storage.ref("assets/image/sky.png");
        ref.putString(dataUrl, "data_url").then(() => {
          //get url of file

          ref.getDownloadURL().then((url) => {
            //save to db under client.sky
            db.ref("client/sky").set(url);
          });
        });
      };
      reader.readAsDataURL(file);
    };

    input.click();
  }

  useEffect(() => {
    if (client && !client.camera) {
      db.ref("/client/camera").set({ position: [0, 0, 0] });
    }
  }, [client]);

  return (
    <div className="flex-1 bg-gray-50 p-2 text-gray-500 relative overflow-y-auto w-[445px]">
      <h3 className="text-xl mb-10">Scene</h3>

      <h3>Sky</h3>

      <div className="my-4 relative aspect-[2/1] rounded-md shadow-lg w-full bg-white">
        {client && client.sky && (
          <img className="object-contain" src={client.sky} alt="sky" />
        )}

        <button
          onClick={updateSky}
          className="absolute right-0 top-0 m-2 text-white bg-gray-600 rounded-full p-2"
        >
          <RefreshIcon className="w-4 h-4" />
        </button>
      </div>

      <h3>Camera</h3>

      <div className="grid grid-cols-3 gap-3 ">
        {client && (
          <>
            <div className="text-right">Position:</div>
            <Vector3Input
              property={"camera.position"}
              client={client}
              setClient={setClient}
            />
            <div className="text-right">Rotation:</div>
            <PropInput
              property={"camera.rotation"}
              client={client}
              setClient={setClient}
              channels={false}
              className={`text-red-300`}
            />
          </>
        )}
      </div>
    </div>
  );
};

const Vector3Input = ({ property, client, setClient }) => {
  return (
    <div className="col-span-2 grid grid-cols-3 gap-3">
      <PropInput
        property={property}
        client={client}
        setClient={setClient}
        channels={true}
        channel={0}
        className={`text-red-300`}
      />
      <PropInput
        property={property}
        client={client}
        setClient={setClient}
        channels={true}
        channel={1}
        className={`text-green-300`}
      />
      <PropInput
        property={property}
        client={client}
        setClient={setClient}
        channels={true}
        channel={2}
        className={`text-blue-300`}
      />
    </div>
  );
};

function getLastProperty(property, obj) {
  const propertiesArray = property.split(".");

  let lastKey = obj;
  let lastProp;

  propertiesArray.forEach((prop, index) => {
    if (index === propertiesArray.length - 1) {
      lastProp = prop;

      return;
    }

    lastKey = lastKey[prop];
  });

  return [lastKey, lastProp];
}

const PropInput = ({
  property,
  client,
  setClient,
  channels = false,
  channel,
  className,
}) => {
  const [Property, prop] = getLastProperty(
    channels ? property + "." + channel : property,
    client
  );

  return (
    <input
      className={`${className} bg-gray-500 w-full p-2`}
      value={channels ? Property[channel] : Property[prop]}
      type={"number"}
      lang="en"
      step={0.1}
      onChange={(e) => {
        const newValue = e.target.value;

        const newClient = { ...client };

        const [newKey, lastProp] = getLastProperty(
          channels ? property + "." + channel : property,
          newClient
        );

        newKey[lastProp] = parseFloat(newValue);

        setClient(newClient);
      }}
    />
  );
};

export default ScenePanel;
